export default "../css/6ea9e259304049693331d82eff3f9db9.ttf";